import angular from 'angular';

import { downgradedModule } from '../../../ng-app/main';

import DataUsageService from './DataUsageService';
import DataUsageComponent from './DataUsageComponent';

export default angular
  .module('petroCloud.admin.dataUsage', [downgradedModule])
  .service('DataUsageService', DataUsageService)
  .component(DataUsageComponent.name, DataUsageComponent)
  .name;
